import sidebarPaths from './sidebarPaths';
import productPaths from './productPaths';
import usersPaths from './userPaths';
import campaignPaths from './campaignPaths';
import paymentPaths from './paymentPaths';
import orderPaths from './orderPath';
import customerPath from './customerPaths';
import reportPath from './reportPaths';
import accountPaths from './accountPaths';
import dashboardPaths from './dashboardPaths';

const paths = {
  ...sidebarPaths,
  ...productPaths,
  ...usersPaths,
  ...campaignPaths,
  ...paymentPaths,
  ...orderPaths,
  ...customerPath,
  ...accountPaths,
  ...reportPath,
  ...dashboardPaths,
  login: '/login',
  forgetPassword: '/forget-password',
  resetPassword: '/reset-password',
  reportsError: '/reports-error',
  home: '/',
};

export const DEFAULT_PATH = paths.dashboard;
export const DEFAULT_AFFILIATE_PATH = paths.affiliateSalesSummary;

export default paths;
